<section class="container">
<div class="article-container" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <h3 class="mt-0" *ngIf="data?.title">{{ data.titleTr }}</h3>

  <div
    class="mt-5"
    [innerHTML]="data.htmlContent"
    *ngIf="data?.htmlContent"
  ></div>
</div>
</section>